import ReactDOM from "react-dom/client";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements
} from "react-router-dom";
import App from "./App";
import "./index.css";
import TosPage from "./pages/tos/TosPage";
import PrivacyPolicyPage from "./pages/privacyPolicy/PrivacyPolicyPage";
import SupportPage from "./pages/support/SupportPage";
import EmailCollectPage from "./pages/emailCollect/EmailCollectPage";
const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<App />} />
      <Route path="/terms-of-service" element={<TosPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/android-test" element={<EmailCollectPage />} />
    </Route>
  )
);
root.render(
    <RouterProvider router={router} />
);
